import { createContext, useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './shards-dashboard/styles/shards-dashboards.1.1.0.min.css';
import AppRoutes from './AppRoutes';
import AuthRoutes from './AuthRoutes';
import { auth, refreshToken } from './firebase-init';
import Loading from './components/UI/loading';
export const AuthContext = createContext(null);
export default () => {
  if (window.location.pathname.includes('logout')) {
    auth.signOut();
  }
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [authenticatedUser, setAuthenticatedUser] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    refreshToken();
    auth.onIdTokenChanged(async (user) => {
      if (user) {
        const userClaims = await user.getIdTokenResult();

        if (userClaims.claims.role !== 'STUDENT') {
          setAuthenticatedUser(user);
          setRole(userClaims.claims?.role);
          setIsAuthenticated(true);
        }
      } else {
        setAuthenticatedUser(null);
        setIsAuthenticated(false);
      }
    });
  });

  useEffect(() => {
    //clear history if authentication path persists
    if (isAuthenticated && window.location.pathname.includes('login')) {
      window.location.replace('/');
    }
  }, [isAuthenticated]);

  return (
    <AuthContext.Provider
      value={{
        user: authenticatedUser,
        isAuth: isAuthenticated,
        userRole: role,
      }}
    >
      <Router>
        {isAuthenticated === true ? (
          <AppRoutes auth_user={authenticatedUser} />
        ) : isAuthenticated === false ? (
          <AuthRoutes />
        ) : (
          <Loading />
        )}
      </Router>
    </AuthContext.Provider>
  );
};
